import { Link, Paragraph } from '@customerio/pluma-components/react';
import redshiftLogo from '@/assets/images/integrations/redshift.svg';
import { ConnectorLanding } from './components/connector-landing';
import type { WarehouseLandingPageProps } from './types';

export default function RedshiftPage({ workspaceId, sync, showPremiumLabel }: WarehouseLandingPageProps) {
  return (
    <ConnectorLanding
      workspaceId={workspaceId}
      sync={sync}
      showPremiumLabel={showPremiumLabel}
      logoSrc={redshiftLogo}
      title="Amazon Redshift"
      blurb="Redshift is a fully managed, petabyte-scale data warehouse service in the cloud. Store and query structured and semi-structured data using standard SQL."
      ingestStep={
        <Paragraph size="xs" color="subtle" mt="050" mb="200">
          There are many approaches to this, but typically requires a COPY command to load the parquet files from your
          bucket. Once loaded, set an expiration on the parquet files so they get automatically deleted.{' '}
          <Link
            href="https://docs.aws.amazon.com/redshift/latest/dg/tutorial-loading-data.html"
            variant="secondary"
            isExternal={true}
          >
            View Amazon&apos;s documentation
          </Link>{' '}
          on loading data into Redshift.
        </Paragraph>
      }
    />
  );
}
